export default "__VITE_ASSET__33761a26__"